import { useEffect } from "react";
export const Sprite = ({
  backgroundColor,
  image,
  position,
  paused,
  style,
  ...rest
}) => {
  let background = "#900";
  if (image) {
    background = `url('${image}')`;
  } else if (backgroundColor) {
    background = backgroundColor;
  }

  if (paused) background = "#900";

  return (
    <div
      style={{
        position: "absolute",
        top: position.y,
        left: position.x,
        width: position.width,
        height: position.height,
        display: position.off ? "none" : "block",
        overflow: image ? "visible" : "hidden",
        pointerEvents: "none",
        ...style,
      }}
      id={position.id}
      {...rest}
      className={rest.className}
    >
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          background,
          backgroundSize: "cover",
          backgroundPosition: "bottom  center",
          backgroundRepeat: "no-repeat",
          width: position.width,
          height: position.height * 2,
        }}
      />
    </div>
  );
};
